import { render, staticRenderFns } from "./CEditableDetail.vue?vue&type=template&id=0d6edbed&scoped=true&"
import script from "./CEditableDetail.vue?vue&type=script&lang=ts&"
export * from "./CEditableDetail.vue?vue&type=script&lang=ts&"
import style0 from "./CEditableDetail.vue?vue&type=style&index=0&id=0d6edbed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6edbed",
  null
  
)

export default component.exports